module.exports = __webpack_public_path__ + "img/take-photo.b3fe74df.png";